import { calculateRoomPrice } from "../utils/_calculateRoomPrice";

export const handleStepTwo = (
  rooms,
  setActiveRoom,
  setActiveGuest,
  currentRoom,
  increaseStep,
  decreaseStep,
  setIsBtnDisabled,
  reverse
) => {
  if (reverse) {
    const prevRoomIndex = currentRoom.id - 1;

    if (prevRoomIndex >= 0) {
      setActiveRoom(prevRoomIndex);
    } else {
      decreaseStep();
      setActiveRoom(0);
    }
  } else {
    const nextRoomIndex = currentRoom.id + 1;

    if (nextRoomIndex < rooms.length) {
      setActiveRoom(nextRoomIndex);
      setActiveGuest(0);
    } else {
      increaseStep();
      setActiveRoom(0);
      setActiveGuest(0);
    }
    setIsBtnDisabled(true);
  }
};

export const handleStepThree = (
  rooms,
  setActiveRoom,
  currentRoom,
  activeGuest = 0,
  setActiveGuest,
  increaseStep,
  decreaseStep,
  setIsBtnDisabled,
  reverse
) => {
  if (reverse) {
    const prevGuest = activeGuest - 1;

    if (prevGuest >= 0) {
      setActiveGuest(prevGuest);
    } else {
      const prevRoomIndex = currentRoom.id - 1;

      if (prevRoomIndex >= 0) {
        setActiveRoom(rooms[prevRoomIndex].id);
      } else {
        decreaseStep();
        setActiveRoom(rooms[rooms.length - 1].id);
      }
    }
  } else {
    const nextGuest = activeGuest + 1;

    if (nextGuest < currentRoom.people.length) {
      setActiveGuest(nextGuest);
      setIsBtnDisabled(true);
    } else {
      const nextRoomIndex = currentRoom.id + 1;
      if (nextRoomIndex < rooms.length) {
        setActiveGuest(0);
        setActiveRoom(rooms[nextRoomIndex].id);
        setIsBtnDisabled(true);
      } else {
        setActiveRoom(rooms[0].id);
        setIsBtnDisabled(true);
        increaseStep();
      }
    }
  }
};

export const handleStepFour = (
  rooms,
  arrivalDate,
  setArrivalDate,
  updatePrice,
  setExpress,
  increaseStep,
  decreaseStep,
  reverse,
  setExpressCount
) => {
  if (reverse) {
    setArrivalDate(null);
    decreaseStep();
  } else {
    calculateRoomPrice(rooms, arrivalDate, updatePrice, setExpress, setExpressCount);
    increaseStep();
  }
};